module.exports = __webpack_public_path__ + "static/img/HK-TF1.5998ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HK-TF1.png
// module id = XEAt
// module chunks = 4